import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IndexFormationListe } from 'src/models/indexFormationListe';
import { IndexFormationDetail } from 'src/models/indexFormationDetail';
import { UtilisateurService } from './utilisateur.service';

@Injectable({
  providedIn: 'root'
})
export class IndexFormationService {

  private baseUrl = environment.api_LMS + 'IndexFormation';

  constructor(
    private http: HttpClient,
    private utilisateurService: UtilisateurService
  ) { }

  getFormations(): Observable<IndexFormationListe[]> {
    const entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;
    const utilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    return this.http.get<IndexFormationListe[]>(
      `${this.baseUrl}/ObtenirFormations`,
      { params: { entiteId: entiteId, utilisateurId: utilisateurId } }
    );
  }

  getFormation(nomPackage: string): Observable<IndexFormationDetail> {
    return this.http.get<IndexFormationDetail>(`${this.baseUrl}/ObtenirFormation/${encodeURIComponent(nomPackage)}`);
  }
}
